import React from "react";
import { useThemeMode } from "../../../context/contextTheme";
import { useAzureIp } from "../../../context/Dashboard/azure/contextIp";
import { ResponsiveContainer, PieChart, Pie, Legend, Tooltip } from "recharts";

const PieChartGraph = () => {
  const { theme } = useThemeMode();
  const { nCV, nHV, nMV, nLV, azureIpVulTableAll, ipAssets } = useAzureIp();

  // Normalize states
  const hasAssets =
    Array.isArray(ipAssets) && ipAssets.length > 0;

  const hasVulTable =
    Array.isArray(azureIpVulTableAll) && azureIpVulTableAll.length > 0;

  const networkData = [
    { name: "Critical", value: nCV || 0, fill: "#6d2d9d" },
    { name: "High",     value: nHV || 0, fill: "#fc0000" },
    { name: "Medium",   value: nMV || 0, fill: "#ffc000" },
    { name: "Low",      value: nLV || 0, fill: "#92d14f" },
  ];

  const filteredPieData = networkData.filter(d => d.value > 0);
  const hasSlices = filteredPieData.length > 0;

  const renderCustomizedLabel = ({ name, value }) => `${name}: ${value}`;

  // Empty states
  if (!hasAssets) {
    return (
      <Card theme={theme} title="Network Vulnerability Distribution">
        <EmptyMsg theme={theme} icon="bi-play-fill" text="Initiate a scan to generate vulnerability data." />
      </Card>
    );
  }

  if (!hasVulTable) {
    return (
      <Card theme={theme} title="EC2 Vulnerability Distribution">
        <EmptyMsg theme={theme} icon="bi-shield-fill-check" text="No EC2 vulnerabilities table available yet." />
      </Card>
    );
  }

  if (!hasSlices) {
    return (
      <Card theme={theme} title="EC2 Vulnerability Distribution">
        <EmptyMsg theme={theme} icon="bi-shield-fill-check" text="No EC2 vulnerabilities detected. Nothing to plot." />
      </Card>
    );
  }

  // Render chart
  return (
    <Card theme={theme} title="EC2 Vulnerability Distribution">
      <div className="p-2">
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={filteredPieData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={80}
              outerRadius={100}
              label={renderCustomizedLabel}
              isAnimationActive={false}
            />
            <Legend
              iconSize={10}
              layout="vertical"
              verticalAlign="middle"
              align="right"
              wrapperStyle={{ color: theme.textColor }}
            />
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

const Card = ({ theme, title, children }) => (
  <div className="p-2">
    <div
      className="card rounded-4 shadow-sm"
      style={{
        width: "calc(620px + 1rem)",
        height: 400,
        backgroundColor: theme.background,
        border: `1px solid ${theme.border}`,
      }}
    >
      <div className="card-body">
        <h6
          className="card-title fw-semibold text-center mt-4"
          style={{ fontSize: 20, color: theme.textColor }}
        >
          {title}
        </h6>
        {children}
      </div>
    </div>
  </div>
);

const EmptyMsg = ({ theme, icon, text }) => (
  <div className="h-75 d-flex flex-column justify-content-center align-items-center">
    <i className={`bi ${icon} fs-1`} style={{ color: theme.textMuted }}></i>
    <p className="fw-semibold mt-2" style={{ color: theme.textMuted }}>
      {text}
    </p>
  </div>
);

export default PieChartGraph;